import { useState } from 'react';
import { ILease } from '../../../types/lease';
import Uploads from './Uploads';

const Miscellaneous = (props: ChildProps) => {
  const { lease } = props;
  const [miscellaneous, setMiscellaneous] = useState(lease.uploads);

  return (
    <div>
      <Uploads lease={lease} state={miscellaneous} setState={setMiscellaneous} type={'uploads'} />
    </div>
  );
};

interface ChildProps {
  lease: ILease;
}

export default Miscellaneous;
